import { render, staticRenderFns } from "./PromotionsSplide.vue?vue&type=template&id=3775b796&"
import script from "./PromotionsSplide.vue?vue&type=script&lang=js&"
export * from "./PromotionsSplide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports